import type { INodeConfigProps } from './index';

/**
 * `template-render` nodes interpolate a Handlebars template against the
 * incoming node input and emit `{ rendered }`. Mirrors the runtime
 * schema in `packages/node-types/src/template-render/index.ts`:
 *   - `templateSource` (required) — the Handlebars source
 *   - `strict` (optional, default false) — throws on missing fields
 */
export function TemplateRenderConfig({ config, onChange }: INodeConfigProps) {
  const templateSource = typeof config.templateSource === 'string' ? config.templateSource : '';
  const strict = config.strict === true;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--sp-3)' }}>
      <label className="field">
        <span className="field-label">Template source (Handlebars)</span>
        <textarea
          className="input"
          rows={6}
          value={templateSource}
          onChange={(e) => onChange({ templateSource: e.target.value })}
          placeholder="Alarm code {{alarmCode}} on device {{deviceId}}"
          spellCheck={false}
          style={{ fontFamily: 'var(--font-mono, monospace)', fontSize: 12 }}
        />
        <span className="field-help">
          Rendered against the node&apos;s input. Output is{' '}
          <code className="t-mono">{'{ rendered }'}</code>.
        </span>
      </label>

      <label
        style={{ display: 'flex', alignItems: 'center', gap: 'var(--sp-2)', cursor: 'pointer' }}
      >
        <input
          type="checkbox"
          className="checkbox"
          checked={strict}
          onChange={(e) => onChange({ strict: e.target.checked })}
        />
        <span className="t-sm">Strict mode (throw on missing input fields)</span>
      </label>
    </div>
  );
}
